import { jsxs as _jsxs } from "react/jsx-runtime";
import * as styles from "./MetaChip.css.js";
// A bordered pill of trip metadata in the detail header — dates, traveller count,
// templates applied, or (highlighted) the countdown. Design system: `core/MetaChip`.
export const MetaChip = ({ icon, highlight = false, clickable = false, peopleChip = false, children }) => (_jsxs("span", { className: [
        styles.base,
        styles.tone[highlight ? "highlight" : "normal"],
        clickable ? styles.clickable : "",
        peopleChip ? styles.peopleChip : "",
    ]
        .filter(Boolean)
        .join(" "), children: [icon, children] }));
//# sourceMappingURL=MetaChip.js.map